import BplsLogoImageShort from "./../../../asset/img/bpls/bpls-logo-short.svg"
import BplsLogoImage from "./../../../asset/img/bpls/bpls-logo.png"
import React from "react"

const BplsLogo = () => {
  return (
    <>
      <img src={BplsLogoImageShort} alt="BPLS Logotype" className="d-block d-md-none" />
      <img src={BplsLogoImage} alt="BPLS long" className="d-none d-md-block" />
    </>
  )
}

export default BplsLogo
